import React from 'react'
import * as yup from 'yup'

import { FormattedMessage } from '@divvy-web/i18n'

import { email } from '@sputnik/schema/creditApplication/person'

export const emailVerificationFormValidationSchema = yup.object().shape({
  email: email.required(() => (
    <FormattedMessage
      defaultMessage='Email is required to continue'
      id='sputnik.emailVerificationFormValidationSchema__ZShXt1'
    />
  )),
})

export type EmailVerificationFormValidationSchema = yup.InferType<typeof emailVerificationFormValidationSchema>
